import * as React from 'react';
import { UserOrganisation } from '../../app/ApiGen';
import { InputComponentProps, ValueComponentProps } from '../../design-system';
import { SelectionMenu } from '../SelectionMenu';

export const OrganisationValue: React.FC<ValueComponentProps<UserOrganisation | undefined>> = ({ value }) => {
  if (!value) {
    return null;
  }

  return <>{value.name}</>;
};

export interface OrganisationInputProps extends InputComponentProps<UserOrganisation> {
  organisations: UserOrganisation[];
}

export const OrganisationInput: React.FC<OrganisationInputProps> = ({
  disabled,
  error,
  helperText,
  name,
  onBlur,
  onChange,
  organisations,
  value,
}) => (
  <SelectionMenu
    defaultValue={value}
    disabled={disabled}
    error={error}
    helperText={helperText}
    name={name}
    onBlur={onBlur}
    onChange={onChange}
    options={organisations.map((organisation) => ({ value: organisation.id, label: organisation.name }))}
  />
);
